// Stat Counters Animation Module
export function initializeStatCounters() {
  const statNumbers = document.querySelectorAll('.stat-number[data-target]');

  if (!statNumbers.length) {
    return;
  }

  const animateCounter = element => {
    const target = parseInt(element.getAttribute('data-target'));
    const duration = 2000; // 2 seconds
    const increment = target / (duration / 16); // 60 FPS
    let current = 0;

    const updateCounter = () => {
      current += increment;
      if (current < target) {
        element.textContent = Math.floor(current);
        requestAnimationFrame(updateCounter);
      } else {
        element.textContent = target;
      }
    };

    updateCounter();
  };

  // Use Intersection Observer for better performance
  const observer = new IntersectionObserver(
    entries => {
      entries.forEach(entry => {
        if (
          entry.isIntersecting &&
          !entry.target.classList.contains('animated')
        ) {
          entry.target.classList.add('animated');
          animateCounter(entry.target);
        }
      });
    },
    { threshold: 0.5 }
  );

  statNumbers.forEach(stat => observer.observe(stat));
}
